// src/config.ts

const isProduction = process.env.NODE_ENV === 'production';

// OLD: const PROD_URL = 'https://www.ailabquant.com/api'; 
// NEW: Point to the subdomain
const PROD_URL = 'https://api.ailabquant.com/api'; 

// Note: We keep the '/api' at the end because your Flask routes are defined 
// as @app.route('/api/...'). 
// So the full URL becomes: https://api.ailabquant.com/api/data/batch_prices

const DEV_URL = 'http://localhost:5001/api';

export const API_BASE_URL = isProduction ? PROD_URL : DEV_URL;